import lozad from 'lozad';

export const initLazyLoad = function() {
  const observer = lozad('.lazy');
  observer.observe();
};
